import { Controller } from '@hotwired/stimulus'

// Generic copy controller
// Usage examples in HTML:
// <div data-controller="copy">
//   <span data-copy-target="source">text to copy</span>
//   <button data-action="click->copy#copy" data-copy-target="button">Copy</button>
// </div>

export default class extends Controller {
  static targets = ['source', 'button']

  copy(event) {
    event && event.preventDefault && event.preventDefault()

    const payload = this._payload()
    if (!payload) return

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(payload).then(() => this._onSuccess(), () => this._fallbackCopy(payload))
    } else {
      this._fallbackCopy(payload)
    }
  }

  _payload() {
    if (this.hasSourceTarget) return this.sourceTarget.textContent.trim()

    // If controller is attached to an input or data attribute, allow fallback
    const value = this.element.getAttribute('data-copy-value')
    if (value) return value.trim()

    // If a button has data-copy-value, use it
    if (this.hasButtonTarget) {
      const btnVal = this.buttonTarget.getAttribute('data-copy-value')
      if (btnVal) return btnVal.trim()
    }

    return ''
  }

  _fallbackCopy(text) {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.left = '-9999px'
    document.body.appendChild(textarea)
    textarea.select()
    try {
      document.execCommand('copy')
      this._onSuccess()
    } catch (e) {
      // eslint-disable-next-line no-alert
      alert('Não foi possível copiar. Por favor, copie manualmente.')
    }
    document.body.removeChild(textarea)
  }

  _onSuccess() {
    if (!this.hasButtonTarget) return

    const flashDisabled = this.element.getAttribute('data-copy-flash') === 'false'

    if (flashDisabled) return

    const btn = this.buttonTarget
    const original = btn.textContent
    const flashText = this.element.getAttribute('data-copy-flash-text') || 'Copiado!'
    btn.textContent = flashText
    setTimeout(() => { btn.textContent = original }, 2000)
  }
}
